export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7777.2964fb79.jpg";